import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./styles/main.scss";
import Header from "./components/Header";
import MosqueList from "./components/MosqueList";
import DistrictFilter from "./components/LocationFilter/LocationFilter";
import DishFilter from "./components/DishFilter/DishFilter";
import { masjidData } from "./utils/MasjidData";
import Footer from "./components/Footer";
import AddMosqueButton from "./components/AddMosqueButton";
import AddMosqueForm from "./components/AddMosqueForm/AddMosqueForm";
import { publicRequest } from "./requestMethods";
import MosqueLoader from "./utils/MosqueLoader";
import MosquePage from "./components/MosquePage/MosquePage";
import ContactPage from "./components/Contact/ContactPage";
import EditMosque from "./components/MosquePage/EditMosque";
import { AuthProvider } from './utils/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { GoogleOAuthProvider } from "@react-oauth/google";
import Login from "./components/Login/Login";
import { Navigate } from "react-router-dom";
import { MapPinOff, Navigation } from 'lucide-react';
import DistrictPage from "./components/DistrictPage/DistrictPage";
import HomePage from "./components/HomePage/HomePage";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import RoutePlannerPage from "./components/RoutePlanner/RoutePlannerPage";
import BecomeContributor from "./components/BecomeContributor/BecomeContributor";
import PhonePromptCheck from "./components/PhonePrompt/PhonePromptCheck";
import ContributorResponsePage from "./components/ContributorResponsePage";
import ContributorResponseRedirect from "./components/ContributorResponseRedirect";
import AnalyticsTracker from "./utils/AnalyticsTracker";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));

  if (!user) {
    // Redirect to login if user is not authenticated, passing current location for redirect after login
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};
function App() {
  return (
    // <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
    //noufalva91@gmail.com
    <GoogleOAuthProvider clientId='557623702455-h0lk0pt9o1rjnm0h62me16enc55gesg0.apps.googleusercontent.com'>
      
      <AuthProvider>
        <SnackbarProvider>
        <PhonePromptCheck />
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mosque/:mosqueID" element={<MosquePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/route-planner" element={<RoutePlannerPage />} />
            <Route path="/contributor-response" element={<ContributorResponsePage />} />
            <Route path="/api/mosques/contributor-response" element={<ContributorResponseRedirect />} />
            <Route path="/city/:cityName" element={<DistrictPage />} />
            <Route path="/:district" element={<DistrictPage />} />
            <Route path="/profile/:emailid" element={<ProfilePage />} />
            <Route path="/become-contributor" element={<BecomeContributor />} />
            <Route path="/musahim" element={<BecomeContributor />} />


            <Route path="/add-mosque" element={
              <ProtectedRoute>
                <AddMosqueForm />
              </ProtectedRoute>
            } />

            <Route path="/edit-mosque/:mosqueID" element={
              <ProtectedRoute>
                <EditMosque />
              </ProtectedRoute>
            } />
            {/* 
          <Route path="/" element={<ProtectedRoute />}>
            <Route path="/add-mosque" element={<AddMosqueForm />} />
            <Route path="/edit-mosque/:mosqueID" element={<EditMosque />} />
          </Route> */}

          </Routes>
        </Router>
        </SnackbarProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

// Separate HomePage component
// function HomePage() {
//   const navigate = useNavigate();
//   const [mosques, setMosques] = useState([]);
//   const [filteredMosques, setFilteredMosques] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedDish, setSelectedDish] = useState("");
//   const [userDistrict, setUserDistrict] = useState("");
//   const [userLocation, setUserLocation] = useState(null);
//   const [nearbyMosques, setNearbyMosques] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isLocating, setIsLocating] = useState(false);
//   const [locationError, setLocationError] = useState(null);



//   useEffect(() => {
//     let filtered = mosques;
//     if (selectedDistrict) {
//       filtered = filtered.filter(mosque => mosque.district === selectedDistrict);
//     }
//     if (selectedDish) {
//       filtered = filtered.filter(mosque => mosque.dish === selectedDish);
//     }
//     setFilteredMosques(filtered);
//   }, [selectedDistrict, selectedDish]);

//   const fetchUserLocation = async (latitude, longitude) => {

//     try {
//       const response = await fetch(
//         `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
//       );
//       const data = await response.json();
//       const district = data.address?.county || data.address?.state_district || "";
//       setUserDistrict(district);
//       setSelectedDistrict(district);

//       const updatedMosques = masjidData
//         .map((mosque) => ({
//           ...mosque,
//           distance: calculateDistance(latitude, longitude, mosque.lat, mosque.lon),
//         }))
//         .filter((mosque) => mosque.distance <= 25);

//       setNearbyMosques(updatedMosques);
//     } catch (err) {
//       setError("Could not determine location.");
//     }
//   };

//   // useEffect(() => {
//   //   if (navigator.geolocation) {
//   //     navigator.geolocation.getCurrentPosition(
//   //       (position) => {
//   //         const { latitude, longitude } = position.coords;
//   //         setUserLocation({ latitude, longitude });
//   //         fetchUserLocation(latitude, longitude);
//   //       },
//   //       () => {
//   //         setError("Location access denied.");
//   //       }
//   //     );
//   //   } else {
//   //     setError("Geolocation is not supported.");
//   //   }
//   // }, []);

//   const handleShowNearby = () => {
//     setIsLocating(true);
//     setLocationError(null);

//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const { latitude, longitude } = position.coords;
//           // Here you can handle the coordinates, e.g., pass to parent or store in state
//           console.log("Location:", latitude, longitude);
//           setIsLocating(false);
//           fetchUserLocation(latitude, longitude);
//           setUserLocation({ latitude, longitude });
//         },
//         (error) => {
//           console.error("Error getting location:", error);
//           setLocationError("Could not get your location");
//           setIsLocating(false);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 5000,
//           maximumAge: 0
//         }
//       );
//     } else {
//       setLocationError("Location is not supported by your browser");
//       setIsLocating(false);
//     }
//   };


//   useEffect(() => {
//     const fetchMosques = async () => {
//       setIsLoading(true);
//       try {
//         const response = await publicRequest.get("/mosques/get-all-mosques"); // Replace with actual API
//         // console.log("mosques fetched", response.data);  

//         setMosques(response.data);
//         setFilteredMosques(response.data);
//         setIsLoading(false);
//       } catch (error) {
//         setError("Failed to fetch mosques. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMosques();
//   }, []);

//   const calculateDistance = (lat1, lon1, lat2, lon2) => {
//     const toRad = (value) => (value * Math.PI) / 180;
//     const R = 6371;
//     const dLat = toRad(lat2 - lat1);
//     const dLon = toRad(lon2 - lon1);
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
//       Math.sin(dLon / 2) * Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     return R * c;
//   };

//   const handleAddMosque = () => {
//     navigate('/add-mosque');
//   };

//   return (
//     <div className="app">
//       <Header />
//       {isLoading && <MosqueLoader />}

//       <button
//         className={`nearby-button ${isLocating ? 'locating' : ''}`}
//         onClick={handleShowNearby}
//         disabled={isLocating}
//       >
//         {isLocating ? (
//           <span className="locating-text">
//             <Navigation className="icon spinning" />
//             Getting Location...
//           </span>
//         ) : (
//           <span className="default-text">
//             <Navigation className="icon" />
//             Show Nearby
//           </span>
//         )}
//       </button>
//       {/* <main className="app__main">
//         {locationError && (
//           <div className="location-error">
//             <MapPinOff className="icon" />
//             {locationError}
//           </div>
//         )}
//         <div className="app__location">
//           {userDistrict && <p>Your Location: <strong>{userDistrict}</strong></p>}
//         </div>
//         <div className="app__filters">
//           <div className="filter-container">
//             <DistrictFilter
//               selectedDistrict={selectedDistrict}
//               onDistrictChange={setSelectedDistrict}
//             />
//             <DishFilter
//               selectedDish={selectedDish}
//               onDishChange={setSelectedDish}
//             />
//           </div>
//         </div>
//         {error ? (
//           <div className="app__error">{error}</div>
//         ) : (
//           <MosqueList mosques={filteredMosques} loading={loading} />
//         )}
//       </main> */}
//       <HomePage />
//       <AddMosqueButton onClick={handleAddMosque} />
//       <Footer />
//     </div>
//   );
// }

export default App;
